export const handleApiResponse = async (response, logout) => {
    const data = await response.json();

    if (!response.ok) {
        if (data?.error === "Invalid token.") {
            alert("세션이 만료되었습니다. 다시 로그인해주세요."); // Session expired message (customize Korean)
            await logout();
        }
        throw new Error(data?.error || "오류가 발생했습니다."); // Throw so you can catch elsewhere
    }

    return data;
};
